import { scaleLinear } from "d3-scale";
import Decimal from "decimal.js";
import { Colours } from "@learningblocks/shared-components";

const PERCENTAGE = {
  HALF: 50,
  MIN: 0,
  MAX: 100,
};

function getSelectedPercentage({ min, max, value }) {
  return scaleLinear()
    .domain([min, max])
    .range([PERCENTAGE.MIN, PERCENTAGE.MAX])(value);
}

export function showRulers(scaleInterval) {
  if (scaleInterval > 0) return true;
  else return false;
}

export function getSliderStyle({ min, max, value }) {
  const selectedPercentage = getSelectedPercentage({ min, max, value });
  let background = Colours.colorPrimaryTone80;
  if (selectedPercentage > PERCENTAGE.HALF) {
    background = `linear-gradient(to right, ${
      Colours.colorSecondaryBlue
    } ${selectedPercentage}%, ${Colours.colorPrimaryTone80} ${
      PERCENTAGE.MAX - selectedPercentage
    }%)`;
  } else {
    background = `linear-gradient(to left, ${Colours.colorPrimaryTone80} ${
      PERCENTAGE.MAX - selectedPercentage
    }%,  ${Colours.colorSecondaryBlue} ${selectedPercentage}% )`;
  }
  return { background };
}

export function getTooltipLeft({ min, max, value, ele }) {
  const scaledLeft = scaleLinear()
    .domain([min, max])
    .range([ele.clientLeft, ele.clientWidth])(value);
  const varience = scaleLinear().domain([min, max]).range([8, 32])(value);
  return { left: `${scaledLeft - varience}px` };
}

export function generateRulerPoints(min, max, scaleInterval) {
  const list = [];
  let point = new Decimal(max);

  while (point >= min) {
    list.push(point);
    point = point.minus(scaleInterval);
  }

  return list;
}
